// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apply-page-wrapper {
  min-height: 100vh;
  background: var(--bg-deep-space, #0b0f17);
  color: #f8fafc;
  padding-bottom: 4rem;
}

.apply-header-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(12px);
}

.apply-logo-link {
  display: inline-block;
  text-decoration: none;
}

.apply-container {
  max-width: 850px;
  margin: 3rem auto 0;
  padding: 0 1.5rem;
}

.full-apply-box {
  background: rgba(18, 24, 38, 0.95) !important;
  border: 1px solid rgba(245, 158, 11, 0.25) !important;
  border-radius: 24px !important;
  padding: 3rem 2.5rem !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6), 0 0 30px rgba(245, 158, 11, 0.1) !important;
}

.apply-main-heading {
  font-size: clamp(1.8rem, 4vw, 2.4rem);
  color: #ffffff;
  margin-top: 0.5rem;
  font-weight: 800;
  line-height: 1.25;
}

.apply-sub-heading {
  color: #94a3b8;
  font-size: 0.95rem;
  margin-top: 0.5rem;
  line-height: 1.5;
}

.btn-apply-submit {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1.25rem;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  font-weight: 800;
  color: #0f172a;
  background: linear-gradient(135deg, #f59e0b 0%, #ea580c 100%);
  border: none;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.35);
}

.btn-apply-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(245, 158, 11, 0.5);
}

.btn-apply-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Responsive queries */
@media (max-width: 768px) {
  .apply-container {
    margin-top: 1.5rem;
    padding: 0 1rem;
  }

  .full-apply-box {
    padding: 2rem 1.25rem !important;
    border-radius: 16px !important;
  }

  .apply-main-heading {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/ApplyPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kDAAkD;EAClD,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,qDAAqD;EACrD,8BAA8B;EAC9B,+BAA+B;EAC/B,uFAAuF;AACzF;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gCAAgC;IAChC,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".apply-page-wrapper {\n  min-height: 100vh;\n  background: var(--bg-deep-space, #0b0f17);\n  color: #f8fafc;\n  padding-bottom: 4rem;\n}\n\n.apply-header-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.8);\n  backdrop-filter: blur(12px);\n}\n\n.apply-logo-link {\n  display: inline-block;\n  text-decoration: none;\n}\n\n.apply-container {\n  max-width: 850px;\n  margin: 3rem auto 0;\n  padding: 0 1.5rem;\n}\n\n.full-apply-box {\n  background: rgba(18, 24, 38, 0.95) !important;\n  border: 1px solid rgba(245, 158, 11, 0.25) !important;\n  border-radius: 24px !important;\n  padding: 3rem 2.5rem !important;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6), 0 0 30px rgba(245, 158, 11, 0.1) !important;\n}\n\n.apply-main-heading {\n  font-size: clamp(1.8rem, 4vw, 2.4rem);\n  color: #ffffff;\n  margin-top: 0.5rem;\n  font-weight: 800;\n  line-height: 1.25;\n}\n\n.apply-sub-heading {\n  color: #94a3b8;\n  font-size: 0.95rem;\n  margin-top: 0.5rem;\n  line-height: 1.5;\n}\n\n.btn-apply-submit {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 1.25rem;\n  padding: 1rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 800;\n  color: #0f172a;\n  background: linear-gradient(135deg, #f59e0b 0%, #ea580c 100%);\n  border: none;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.35);\n}\n\n.btn-apply-submit:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(245, 158, 11, 0.5);\n}\n\n.btn-apply-submit:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Responsive queries */\n@media (max-width: 768px) {\n  .apply-container {\n    margin-top: 1.5rem;\n    padding: 0 1rem;\n  }\n\n  .full-apply-box {\n    padding: 2rem 1.25rem !important;\n    border-radius: 16px !important;\n  }\n\n  .apply-main-heading {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
